<template>
    <div>
        <b-modal size="xl" ref="finderModal" :title="prefix + title" hide-footer>
            <ImpressoraList @close="impressoraSelect" :title="prefix + title + ' >'" />
        </b-modal>
        <lg-form-input-finder v-model="inputValue" fieldDescription="nome" :label="label"
            invalidFeedback="Impressora deve ser informada!" description="" @click:button="show"
            @clear="handleClear">
            <template #prepend>
                <b-button @click="show" class="btn-input-finder" pressed>
                    <b-icon icon="search" />
                </b-button>
            </template>
        </lg-form-input-finder>
    </div>
</template>

<script>
import ImpressoraList from "@/modules/cadastros/impressora/ImpressoraList.vue";
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue";

export default {
    components: { LgFormInputFinder, ImpressoraList },

    props: {
        id: String,
        value: Object,
        prefix: {
            type: String,
            default: "",
        },
        label: {
            type: String,
            default: "Impressora",
        },
    },

    data() {
        return {
            inputValue: this.value,
            title: "Impressora",
        };
    },

    watch: {
        value(newValue) {
            this.inputValue = newValue;
        },
        inputValue(newValue) {
            this.$emit("input", newValue);
        },
    },

    methods: {
        show() {
            this.$refs.finderModal.show();
        },

        handleClear() {
            this.inputValue = null;
            this.$emit("input", null);
            this.$refs.finderModal.hide();

        },

        impressoraSelect(item) {
            this.inputValue = item;
            this.$emit("input", item);
            this.$refs.finderModal.hide();

        },
    },
};
</script>
